import { dashedToCamelCase, capitalize } from 'src/js/modules/utils/convert-case';

const generateAdjustedEventTraits = (prefixPart, mainPart, value) => {
  const prefix = dashedToCamelCase(prefixPart);
  const main = capitalize(dashedToCamelCase(mainPart));
  const traitName = `${prefix}${main}Adjusted`;

  return {
    [traitName]: value,
  };
};

export default generateAdjustedEventTraits;
